<template>
  <!-- Add a wrapper (like: <span>...</span>) around the vendor's component to props in this component being directly passed  to the vendor's one  -->
  <span>
    <vue-number
      ref="vueNumber"
      v-model="price"
      v-bind="number"
      :disabled="disabled"
      onkeypress="return event.keyCode === 8 || event.charCode >= 48 && event.charCode <= 57"
      @change="onChange"
    />
  </span>
</template>
<script>
import { component as VueNumber } from '@coders-tm/vue-number-format'
export default {
  props: {
    value: {
      default: null
    },
    disabled: {
      default: false
    }
  },
  component: {
    VueNumber
  },
  data() {
    return {
      price: null,
      money: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 0,
        masked: false /* doesn't work with directive */
      },
      number: {
        decimal: '.',
        separator: ',',
        precision: 2
      }
    }
  },
  watch: {
    value: {
      handler(value) {
        this.price = value !== null ? value : ''
      },
      immediate: true
    },
    price(value) {
      if (String(value).length > 18) {
        this.$message({
          message: 'Số tiền quá lớn',
          type: 'error'
        })
        this.$emit('input', null)
      } else {
        if (value) {
          this.$emit('input', Number(String(value).replaceAll('.', '')))
        } else if (value === '') {
          this.$emit('input', null)
        }
      }
    }
  },
  mounted() {
    this.$refs.vueNumber.$el.addEventListener('blur', this.onBlur)
    this.$refs.vueNumber.$el.addEventListener('click', this.onClick)
  },
  methods: {
    onChange() {
      this.$emit('change')
    },
    onBlur() {
      this.$emit('blur')
    },
    onClick(e) {
      this.$emit('click', e)
    }
  }
}
</script>
